export { LinkPatientRecordsModal } from "./link-patient-records-modal";
export { ResourceTab } from "./types";